/**
 * Flagsmith Context Provider
 * Created: 2025-01-17
 *
 * Provides Flagsmith feature flag functionality to the oauth-webapp
 * Based on implementation patterns from console-webapp and trade-webapp
 */

'use client'

import React, {useRef} from 'react'
import {createFlagsmithInstance} from 'flagsmith/isomorphic'
import {FlagsmithProvider} from 'flagsmith/react'

interface FlagsmithContextProviderProps {
  children: React.ReactNode
  environmentID?: string
  apiUrl?: string
}

export const FlagsmithContextProvider = ({children, environmentID, apiUrl = 'https://flagsmith.frnt.io/api/v1/'}: FlagsmithContextProviderProps) => {
  const flagsmithRef = useRef(createFlagsmithInstance())

  // Don't render if no environment ID is provided
  if (!environmentID) {
    console.warn('Flagsmith environment ID not provided, feature flags will not be available')
    return children as React.ReactElement
  }

  return (
    <FlagsmithProvider
      options={{
        environmentID,
        api: apiUrl
      }}
      flagsmith={flagsmithRef.current}>
      {children as React.ReactElement}
    </FlagsmithProvider>
  )
}
